import { lazy } from "react";

const components = {
  text_box_and_rich_text: lazy(() => import("./TextBoxWithRichText")),
  text_box_and_form: lazy(() => import("./TextBoxWithForm")),
  google_map: lazy(() => import("./GoogleMapEmbed")),
  single_image: lazy(() => import("./SingleImage")),
  two_images: lazy(() => import("./TwoImages")),
  slider: lazy(() => import("./ProjectSlider")),
  featured_projects: lazy(() => import("./FeaturedProjects")),
};

export default components;
